import Button from '@mui/material/Button';
import { teal } from '@mui/material/colors';
import Grid from '@mui/material/Grid';
import React, { Component } from 'react';
import AboutSelect from '../../components/About/AboutSelect';
import CookiesText from '../../components/About/Texts/Cookies';
import Footer from '../../components/General/Footer';
import HeaderCard from '../../components/General/HeaderCard';
import Head from '../../components/Header/Head';
import Header from '../../components/Header/Header';
import {
  deleteCookieConsent,
  hasCookieConsent,
  setCookieConsent,
} from '../../helpers/token';
import withApollo from '../../lib/withApollo';

class CookiesPage extends Component {
  state = {
    optin: false,
  };

  componentDidMount() {
    const cookie = hasCookieConsent() === 'true';
    this.setState({ optin: cookie });
  }

  decline() {
    this.setState({ optin: false });
    deleteCookieConsent();
  }

  accept() {
    setCookieConsent('true');
    this.setState({ optin: true });
  }

  render() {
    const { optin } = this.state;
    const title = 'Cookies';
    return (
      <>
        <Header subheader={title} active="cookies" />
        <Head title={`${title}`} />
        <AboutSelect selection={7} />
        <Grid
          container
          spacing={0}
          alignItems="center"
          justifyContent="center"
          className="pt-4 pb-4"
        >
          <Grid item lg={7} md={8} sm={11} xs={12}>
            <HeaderCard
              title="Cookie Policy"
              background={teal[600]}
              content={<CookiesText />}
            />
          </Grid>
          <Grid item lg={7} md={8} sm={11} xs={12} className="pt-3">
            <HeaderCard
              title="Change Cookie Consent"
              background={teal[600]}
              content={
                <>
                  <p>
                    {' '}
                    Your current cookie Settings are:{' '}
                    {(optin && (
                      <>
                        <strong>You are opted in.</strong>{' '}
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => this.decline()}
                        >
                          Opt out
                        </Button>{' '}
                        <br />
                        <em>
                          Cookies that are already set will not be removed by
                          changing this setting.
                        </em>
                      </>
                    )) || (
                      <>
                        <strong>You are opted out.</strong>{' '}
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => this.accept()}
                        >
                          Opt in
                        </Button>
                      </>
                    )}
                  </p>
                  <p>
                    These option only applies to EU-users. If you are accessing
                    this page from outside the EU, pressing the &quot;opt
                    out&quot; button will have no effect since you are opted in
                    by default on every page load. Instead, you can opt-out by
                    updating your browser&apos;s cookie settings.
                  </p>
                </>
              }
            />
          </Grid>
        </Grid>
        <Footer />
      </>
    );
  }
}

export default withApollo(CookiesPage);
